// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/myAccount/drop-arrow-gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
/* success modal overlay */
.paymentForm_successOverlay__Mrhx0 {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1600;
  /* higher than loaderOverlay (1400) */
  background: rgba(6, 8, 15, 0.25);
}

/* success modal card */
.paymentForm_successModal__ZRFPZ {
  width: 420px;
  max-width: calc(100% - 32px);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(16, 24, 40, 0.12);
  padding: 18px;
  position: relative;
}

/* close button */
.paymentForm_successClose__KgT6e {
  position: absolute;
  top: 8px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
}

/* body */
.paymentForm_successBody__c1nGb {
  text-align: center;
  padding: 8px 6px 2px;
}

.paymentForm_successTitle__Lns1X {
  margin: 0 0 8px;
  color: #0f1724;
  font-size: 18px;
  font-weight: 700;
}

.paymentForm_successText__AifVq {
  margin: 0 0 14px;
  color: #374151;
  font-size: 14px;
}

/* actions */
.paymentForm_successActions__Q55Bs {
  display: flex;
  justify-content: center;
}

.paymentForm_successOk__9yUV4 {
  background: var(--accent, #ff7a00);
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
}

.paymentForm_loaderOverlay__2\\+NPG {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1400;
  background: rgba(6, 8, 15, 0.25);
  pointer-events: auto;
}

/* ensure loader child doesn't push to the right */
.paymentForm_loaderOverlay__2\\+NPG > * {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  float: none !important;
  width: auto !important;
}

/* Color palette */
/* primary orange */
/* Root form card */
.paymentForm_form__S5nx3 {
  max-width: 100%;
  margin: 0 auto;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #111827;
}

/* Top row: tabs left, logos right */
.paymentForm_topRow__k91Xc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

/* Keep tabs grouped and left-aligned */
.paymentForm_tabsWrapper__i7UpG {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
}

/* Tabs */
.paymentForm_tabs__NplNR {
  display: flex;
  gap: 12px;
  align-items: center;
}

.paymentForm_tab__WDVH7 {
  padding: 14px;
  border: 1px solid #9e9e9e;
  background: #e6e9ee !important;
  color: #222222;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
  min-width: 180px;
  text-align: center;
}

.paymentForm_active__hj4xY {
  background: #fff !important;
  color: #000 !important;
  border: none;
}

/* Logos wrapper aligns logos to the right */
.paymentForm_logosWrapper__aIpnv {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
}

/* Card logos row styling */
.paymentForm_cardLogosRow__2RqKx {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  margin: 0;
  padding: 0;
}

/* individual logo container */
.paymentForm_cardLogo__Iat54 {
  width: 66px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ensure SVG scales nicely */
.paymentForm_cardSvg__\\+aqOn {
  width: 100%;
  height: auto;
  display: block;
}

/* Panel and headings */
.paymentForm_panel__p3zO6 {
  padding: 10px 15px;
}

.paymentForm_required__QrQjs {
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 12px;
}

/* Labels and inputs */
.paymentForm_label__VSux6 {
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
  color: #111827;
  margin-left: 0px !important;
}

.paymentForm_labelSmall__5ZiOZ {
  display: block;
  width: 100%;
  font-size: 14px;
  margin-left: 0px !important;
}

/* Inputs */
.paymentForm_input__Gn0Qy, .paymentForm_inputError__o4LoF,
select {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e6e6e9;
  border-radius: 8px;
  margin-top: 8px;
  font-size: 14px;
  background: #fff;
  color: #111827;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.paymentForm_input__Gn0Qy:focus, .paymentForm_inputError__o4LoF:focus,
select:focus {
  outline: none;
  border-color: #ff7a00;
  box-shadow: 0 0 0 4px rgba(255, 122, 0, 0.06);
}

.paymentForm_inputError__o4LoF {
  border-color: #d9534f;
  box-shadow: 0 0 0 4px rgba(217, 83, 79, 0.06);
}

/* Row layout */
.paymentForm_row__XfeYM {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 12px;
}

.paymentForm_labelSmall__5ZiOZ {
  width: 50%;
}

/* Fieldset */
.paymentForm_fieldset__pxmwD {
  border: 1px solid #e6e6e9;
  padding: 14px;
  border-radius: 8px;
  margin-bottom: 14px;
  background: #fffaf5;
}

.paymentForm_legend__1ett\\+ {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 8px;
  color: #7a4a00;
}

/* Error text */
.paymentForm_error__3rGj9 {
  color: #d9534f;
  font-size: 12px;
  margin-top: 6px;
  display: block;
}

/* Card icons row (bottom) */
.paymentForm_cardIcons__s8SBG {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  align-items: center;
}

.paymentForm_icon__QkBvh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e6e6e9;
  font-size: 13px;
  color: #374151;
  min-width: 56px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

/* Radio labels */
.paymentForm_radioLabel__XYsHx {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
  font-size: 14px;
}

/* Check sample */
.paymentForm_checkSample__T7zpn {
  margin-top: 12px;
}

.paymentForm_checkGraphic__iN5oj {
  border: 1px dashed #e6e6e9;
  padding: 12px;
  border-radius: 8px;
  background: #fff7ed;
  color: #92400e;
}

.paymentForm_checkRow__kLp7x {
  font-size: 13px;
  margin-bottom: 6px;
}

/* Actions / submit */
.paymentForm_actions__07Ff1 {
  display: flex;
  justify-content: end;
  margin: 2% 5%;
}

.paymentForm_submitBtn__ikImx {
  background: #ffb034 !important;
  color: #fff;
  padding: 12px 18px;
  border-radius: 0;
  border: none;
  font-weight: 700;
  font-size: 25px;
  cursor: pointer;
  transition: transform 0.06s ease, box-shadow 0.12s ease;
}

.paymentForm_form-control__m1n37 {
  outline: none;
  width: 100%;
  border: 1px solid #d7d7d7 !important;
}
.paymentForm_form-control__m1n37::placeholder {
  font-style: italic;
  font-weight: 300;
}

.paymentForm_paymetric--form__A8JCJ select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  height: 42px;
  min-height: 0;
  max-width: 100%;
  padding: 0 50px 0 5px;
  font-size: 14px;
  border: 1px solid #e6e9ee;
  color: #222222;
  font-weight: 300;
}

.paymentForm_submitBtn__ikImx:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 26px rgba(224, 102, 0, 0.14);
}

/* Responsive */
@media only screen and (max-width: 768px) {
  .paymentForm_g-font-size-16__cb9cF, .paymentForm_gfs-16__tNT0g {
    font-size: 14px !important;
  }
  .paymentForm_row__XfeYM {
    flex-direction: column;
  }
  .paymentForm_labelSmall__5ZiOZ {
    width: 100%;
  }
  .paymentForm_tabs__NplNR {
    flex-direction: column;
  }
  .paymentForm_tab__WDVH7 {
    min-width: auto;
    width: 100%;
  }
  .paymentForm_actions__07Ff1 {
    justify-content: stretch;
  }
  .paymentForm_submitBtn__ikImx {
    width: 100%;
  }
  /* stack topRow vertically on small screens */
  .paymentForm_topRow__k91Xc {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .paymentForm_logosWrapper__aIpnv {
    justify-content: flex-start;
  }
}
/* paymentForm.module.scss (append or merge with your existing file) */
/* ACCEPTED CARDS BLOCK */
.paymentForm_acceptCardsBlock__Gr-bK {
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
  justify-content: flex-start;
  align-items: start;
}

/* italic text row (matches g-font-italic gfs-16 paymetric--mb-20) */
.paymentForm_acceptText__bcVue {
  font-style: italic;
  font-size: 12px;
  font-weight: 300;
  padding: 10px 0px 10px !important;
  color: #666;
  word-break: break-all;
}

/* row that contains the small card badges */
.paymentForm_acceptRow__FfMcZ {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* base badge style (paymetric--form_card paymetric--form_card-sm) */
.paymentForm_cardBadge__8W902 {
  width: 56px;
  /* small badge width */
  height: 34px;
  /* small badge height */
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 2px 6px rgba(2, 6, 23, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: 4px;
}

/* Mastercard indicator (mcIndicator) */
.paymentForm_mcIndicator__q9lZ- {
  background: linear-gradient(90deg, #ff5f4d 0%, #ffb347 100%);
  color: #fff;
  position: relative;
}

.paymentForm_mcIndicator__q9lZ-::after {
  content: "Mastercard";
  font-size: 11px;
  color: #fff;
  letter-spacing: 0.2px;
}

/* Visa indicator (viIndicator) */
.paymentForm_viIndicator__m1-q\\+ {
  background: #1a1f71;
  /* Visa dark blue */
  color: #fff;
}

.paymentForm_viIndicator__m1-q\\+::after {
  content: "Visa";
  font-size: 12px;
  color: #fff;
}

/* AmEx indicator (axIndicator) */
.paymentForm_axIndicator__eMAAT {
  background: #2e77bc;
  /* AmEx blue */
  color: #fff;
}

.paymentForm_axIndicator__eMAAT::after {
  content: "AmEx";
  font-size: 11px;
  color: #fff;
}

/* Discover indicator (diIndicator) */
.paymentForm_diIndicator__3ZY9O {
  background: linear-gradient(90deg, #fff 0%, #fff 100%);
  color: #ff6a00;
  border: 1px solid #e6e6e9;
}

.paymentForm_diIndicator__3ZY9O::after {
  content: "Discover";
  font-size: 10px;
  color: #ff6a00;
  font-weight: 700;
}

/* small responsive tweak */
@media (max-width: 480px) {
  .paymentForm_cardBadge__8W902 {
    width: 48px;
    height: 28px;
    font-size: 10px;
  }
  .paymentForm_acceptText__bcVue {
    font-size: 14px;
  }
}
.paymentForm_cardLogosRow__2RqKx {
  display: flex;
  gap: 5px;
  align-items: center;
}

.paymentForm_cardImg__r7P7D {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

.paymentForm_p-0__oqyEK {
  padding: 0 !important;
}

.paymentForm_align-items-end__k7ldT {
  align-items: flex-end !important;
}

.paymentForm_g-font-size-16__cb9cF, .paymentForm_gfs-16__tNT0g {
  font-size: 16px;
}

.paymentForm_g-font-weight-300__31oIm, .paymentForm_gfw-3__7s8x- {
  font-weight: 300 !important;
}

.paymentForm_g-line-height-1_2__8Zts1, .paymentForm_glh-1_2__rcrYh {
  line-height: 1.2 !important;
}

.paymentForm_paymetric--form_radio__5tRPZ div {
  bottom: -1px;
}

.paymentForm_paymetric--form_radio__5tRPZ div {
  bottom: -1px;
}

.paymentForm_d-inline-block__JI0Hg {
  display: inline-block !important;
}

.paymentForm_position-relative__syJpR {
  position: relative !important;
}

.paymentForm_float-left__fkzmS {
  float: left !important;
}

.paymentForm_bg-white-clr__LP0Ut {
  background: #fff !important;
  border-bottom: 1px solid #fff !important;
  padding-top: 19px !important;
  position: relative;
  z-index: 9;
}

.paymentForm_paymetric--form_radio__5tRPZ label {
  border: 1px solid #9e9e9e;
  cursor: pointer;
}

.paymentForm_p-14__XmylH {
  padding: 14px;
}

.paymentForm_m-0__kmW\\+6 {
  margin: 0 !important;
}

.paymentForm_g-font-size-16__cb9cF, .paymentForm_gfs-16__tNT0g {
  font-size: 16px;
}

.paymentForm_g-font-weight-700__ND85V, .paymentForm_gfw-7__zCYkv {
  font-weight: 700 !important;
}

.paymentForm_g-line-height-1__FlzHI, .paymentForm_glh-1__BhaXq {
  line-height: 1 !important;
}

.paymentForm_bg-gray-light__uEqRW {
  background-color: #e6e9ee !important;
}

.paymentForm_paymetric--form_radio__5tRPZ div:last-child {
  left: -1px;
}

.paymentForm_paymetric--form_radio__5tRPZ div {
  bottom: -1px;
}

.paymentForm_d-inline-block__JI0Hg {
  display: inline-block !important;
}

.paymentForm_position-relative__syJpR {
  position: relative !important;
}

.paymentForm_float-left__fkzmS {
  float: left !important;
}

.paymentForm_paymetric--mb-20__tbb6d {
  margin-bottom: 20px !important;
  word-break: break-all;
}

.paymentForm_paymetric--form_wrapper__r9pGy {
  border: 1px solid #9e9e9e;
}

.paymentForm_bg-white__Xw-JC {
  color: #666;
}

.paymentForm_bg-white__Xw-JC {
  background-color: #fff !important;
}

.paymentForm_py-20__YtlM1 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

@media only screen and (max-width: 990px) {
  .paymentForm_paymetric--mb-20__tbb6d {
    margin-bottom: 20px !important;
  }
}
.paymentForm_paymetric--form__A8JCJ {
  font-family: "Source Sans Pro", sans-serif;
}

.paymentForm_g-font-weight-300__31oIm {
  font-weight: 300 !important;
}

.paymentForm_sr-only__HFfaE {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.paymentForm_paymetric--form__A8JCJ input, .paymentForm_paymetric--form__A8JCJ select {
  border: 1px solid #d7d7d7 !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  color: #666 !important;
  padding: 8px 18px;
  left: 0;
  margin-bottom: 0 !important;
}
@media only screen and (max-width: 767px) {
  .paymentForm_paymetric--form__A8JCJ input, .paymentForm_paymetric--form__A8JCJ select {
    border-radius: 0;
    font-weight: 300;
  }
}
.paymentForm_paymetric--form__A8JCJ input ::placeholder, .paymentForm_paymetric--form__A8JCJ select ::placeholder {
  font-style: italic !important;
  font-weight: 300;
}

@media only screen and (max-width: 767px) {
  .paymentForm_paymetric--form__A8JCJ input::placeholder {
    font-style: italic !important;
    font-weight: 300;
  }
}
#paymentForm_PaymentForm__IwYkZ .paymentForm_paymetric__zYfUm {
  border: none;
  min-height: 300px !important;
}

.paymentForm_mb-md-0__Kyblb {
  margin-bottom: 0 !important;
}

.paymentForm_paymetric--mb-20__tbb6d {
  margin-bottom: 20px !important;
  word-break: break-all;
}

.paymentForm_g-font-italic__utfvi {
  font-style: italic !important;
}

.paymentForm_g-font-italic__utfvi.paymentForm_gfs-14__e8wxT.paymentForm_paymetric--mb-20__tbb6d {
  margin-top: 16px;
  display: flex;
}

.paymentForm_form-row__eJLj\\+ {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
@media only screen and (max-width: 990px) {
  .paymentForm_form-row__eJLj\\+ {
    margin-right: 15px;
    margin-left: 15px;
  }
}

#paymentForm_PaymentForm__IwYkZ .paymentForm_paymetric--form_card-sm__YYW9X {
  height: 35px !important;
  opacity: 1 !important;
}

.paymentForm_paymetric--form_card__xqhZC {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  float: left;
  height: 50px;
  width: 83px;
}
@media only screen and (max-width: 767px) {
  .paymentForm_paymetric--form_card__xqhZC {
    opacity: 1;
  }
  .paymentForm_paymetric--form_card__xqhZC img {
    height: 35px;
  }
}

.paymentForm_gfs-14__e8wxT {
  font-size: 14px !important;
}

.paymentForm_btn-primary__HHLUa {
  background-color: #ffb034 !important;
}

.paymentForm_btn-orange__vDwal {
  background-color: #ffb034 !important;
  color: #fff !important;
  font-size: 26px !important;
  font-weight: 700 !important;
}
@media only screen and (max-width: 767px) {
  .paymentForm_btn-orange__vDwal {
    line-height: 1.3 !important;
    border-radius: 0 !important;
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/paymentForm.module.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,oRAAA;ACHF;ADQA;EACE,gCAAA;EACA,wPAAA;ACNF;ADUA;EACE,0CAAA;EACA,wWAAA;ACRF;AAXA,0BAAA;AACA;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,qCAAA;EACA,gCAAA;AAaJ;;AAVA,uBAAA;AACA;EACI,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,kBAAA;AAaJ;;AAVA,iBAAA;AACA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAaJ;;AAVA,SAAA;AACA;EACI,kBAAA;EACA,oBAAA;AAaJ;;AAVA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAaJ;;AAVA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AAaJ;;AAVA,YAAA;AACA;EACI,aAAA;EACA,uBAAA;AAaJ;;AAVA;EACI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAaJ;;AATA;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gCAAA;EACA,oBAAA;AAYJ;;AATA,kDAAA;AACA;EACI,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;AAYJ;;AAPA,kBAAA;AAIA,mBAAA;AAQA,mBAAA;AACA;EACI,eAAA;EACA,cAAA;EACA,yFANS;EAOT,cAAA;AAAJ;;AAGA,oCAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAAJ;;AAGA,uCAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AAAJ;;AAGA,SAAA;AACA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAIA;EACI,2BAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAIA,4CAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AADJ;;AAIA,2BAAA;AACA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AADJ;;AAIA,8BAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAIA,6BAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AADJ;;AAIA,uBAAA;AACA;EACI,kBAAA;AADJ;;AAIA;EACI,cApGI;EAqGJ,eAAA;EACA,mBAAA;AADJ;;AAIA,sBAAA;AACA;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;AADJ;;AAIA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;AADJ;;AAIA,WAAA;AACA;;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0DAAA;AADJ;;AAIA;;EAEI,aAAA;EACA,qBA1IK;EA2IL,6CAAA;AADJ;;AAIA;EAEI,qBA7II;EA8IJ,6CAAA;AAFJ;;AAKA,eAAA;AACA;EACI,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,UAAA;AAFJ;;AAKA,aAAA;AACA;EACI,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAFJ;;AAKA,eAAA;AACA;EACI,cA/KI;EAgLJ,eAAA;EACA,eAAA;EACA,cAAA;AAFJ;;AAKA,4BAAA;AACA;EACI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;AAFJ;;AAKA,iBAAA;AACA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAFJ;;AAKA,iBAAA;AACA;EACI,gBAAA;AAFJ;;AAKA;EACI,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,eAAA;EACA,kBAAA;AAFJ;;AAKA,qBAAA;AACA;EACI,aAAA;EACA,oBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,uDAAA;AAFJ;;AAKA;EACI,aAAA;EACA,WAAA;EACA,oCAAA;AAFJ;AAII;EACI,kBAAA;EACA,gBCnOH;ADiOL;;AAMA;EAGE,gBAAA;EACA,yDAAA;EACA,yBAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAHF;;AAMA;EACI,2BAAA;EACA,+CAAA;AAHJ;;AAKA,eAAA;AACA;EACI;IACA,0BAAA;EAFF;EAIE;IACI,sBAAA;EAFN;EAKE;IACI,WAAA;EAHN;EAME;IACI,sBAAA;EAJN;EAOE;IACI,eAAA;IACA,WAAA;EALN;EAQE;IACI,wBAAA;EANN;EASE;IACI,WAAA;EAPN;EAUE,6CAAA;EACA;IACI,sBAAA;IACA,oBAAA;IACA,SAAA;EARN;EAWE;IACI,2BAAA;EATN;AACF;AAiBA,sEAAA;AAEA,yBAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAhBJ;;AAmBA,oEAAA;AACA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,WAAA;EACA,qBAAA;AAhBJ;;AAmBA,4CAAA;AACA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAhBJ;;AAmBA,oEAAA;AACA;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,0CAAA;EACA,qCAAA;EACA,YAAA;AAhBJ;;AAmBA,uCAAA;AACA;EACI,4DAAA;EACA,WAAA;EACA,kBAAA;AAhBJ;;AAmBA;EACI,qBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AAhBJ;;AAmBA,iCAAA;AACA;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;AAhBJ;;AAmBA;EACI,eAAA;EACA,eAAA;EACA,WAAA;AAhBJ;;AAmBA,iCAAA;AACA;EACI,mBAAA;EACA,cAAA;EACA,WAAA;AAhBJ;;AAmBA;EACI,eAAA;EACA,eAAA;EACA,WAAA;AAhBJ;;AAmBA,qCAAA;AACA;EACI,sDAAA;EACA,cAAA;EACA,yBAAA;AAhBJ;;AAmBA;EACI,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAhBJ;;AAmBA,2BAAA;AACA;EACI;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAhBN;EAmBE;IACI,eAAA;EAjBN;AACF;AAoBA;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAlBJ;;AAqBA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAlBJ;;AAsBA;EACI,qBAAA;AAnBJ;;AAqBA;EACI,gCAAA;AAlBJ;;AAoBA;EACI,eAAA;AAjBJ;;AAmBA;EACI,2BAAA;AAhBJ;;AAkBA;EACI,2BAAA;AAfJ;;AAiBA;EACI,YAAA;AAdJ;;AAgBA;EACI,YAAA;AAbJ;;AAeA;EACI,gCAAA;AAZJ;;AAcA;EACI,6BAAA;AAXJ;;AAaA;EACI,sBAAA;AAVJ;;AAYA;EACM,2BAAA;EACF,wCAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;AATJ;;AAYA;EACI,yBAAA;EACA,eAAA;AATJ;;AAWA;EACI,aAAA;AARJ;;AAUA;EACI,oBAAA;AAPJ;;AASA;EACI,eAAA;AANJ;;AAQA;EACI,2BAAA;AALJ;;AAOA;EACI,yBAAA;AAJJ;;AAMA;EACI,oCAAA;AAHJ;;AAKA;EACI,UAAA;AAFJ;;AAIA;EACI,YAAA;AADJ;;AAGA;EACI,gCAAA;AAAJ;;AAEA;EACI,6BAAA;AACJ;;AACA;EACI,sBAAA;AAEJ;;AAAA;EACI,8BAAA;EACA,qBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AAFA;EACI,WAAA;AAKJ;;AAHA;EACI,iCAAA;AAMJ;;AAJA;EACI,4BAAA;EACA,+BAAA;AAOJ;;AAJA;EACI;IACI,8BAAA;EAON;AACF;AALA;EACI,0CClgBgB;ADygBpB;;AALA;EACI,2BAAA;AAQJ;;AANA;EACI,SAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AASJ;;AAPA;EACI,oCAAA;EACA,gDAAA;EACA,sBAAA;EACA,iBAAA;EACA,OAAA;EACA,2BAAA;AAUJ;AATI;EAPJ;IAQQ,gBAAA;IACA,gBCtiBH;EDkjBH;AACF;AAXI;EACI,6BAAA;EACA,gBC1iBH;ADujBL;;AAVA;EACI;IACI,6BAAA;IACA,gBChjBH;ED6jBH;AACF;AAVA;EACI,YAAA;EACA,4BAAA;AAYJ;;AAVA;EACI,2BAAA;AAaJ;;AAVA;EACI,8BAAA;EACA,qBAAA;AAaJ;;AAXA;EACI,6BAAA;AAcJ;;AAZA;EACI,gBAAA;EACA,aAAA;AAeJ;;AAbA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAgBJ;AAfI;EALJ;IAMQ,kBAAA;IACA,iBAAA;EAkBN;AACF;;AAhBA;EACI,uBAAA;EACA,qBAAA;AAmBJ;;AAjBA;EACI,wBAAA;EACA,4BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAoBJ;AAnBI;EAPJ;IAQQ,UAAA;EAsBN;EArBM;IACI,YAAA;EAuBV;AACF;;AAnBA;EACI,0BAAA;AAsBJ;;AApBA;EACI,oCAAA;AAuBJ;;AArBA;EACI,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;AAwBJ;AAvBI;EALJ;IAMQ,2BAAA;IACA,2BAAA;IACA,sBAAA;EA0BN;AACF","sourcesContent":["// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","@use 'abstracts/variables' as *;\n\n// /* PaymentForm.module.scss */\n/* success modal overlay */\n.successOverlay {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1600;\n    /* higher than loaderOverlay (1400) */\n    background: rgba(6, 8, 15, 0.25);\n}\n\n/* success modal card */\n.successModal {\n    width: 420px;\n    max-width: calc(100% - 32px);\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 12px 40px rgba(16, 24, 40, 0.12);\n    padding: 18px;\n    position: relative;\n}\n\n/* close button */\n.successClose {\n    position: absolute;\n    top: 8px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #6b7280;\n}\n\n/* body */\n.successBody {\n    text-align: center;\n    padding: 8px 6px 2px;\n}\n\n.successTitle {\n    margin: 0 0 8px;\n    color: #0f1724;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.successText {\n    margin: 0 0 14px;\n    color: #374151;\n    font-size: 14px;\n}\n\n/* actions */\n.successActions {\n    display: flex;\n    justify-content: center;\n}\n\n.successOk {\n    background: var(--accent, #ff7a00);\n    color: #fff;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 700;\n}\n\n\n.loaderOverlay {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1400;\n    background: rgba(6, 8, 15, 0.25);\n    pointer-events: auto;\n}\n\n/* ensure loader child doesn't push to the right */\n.loaderOverlay>* {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin: 0 !important;\n    float: none !important;\n    width: auto !important;\n}\n\n\n\n/* Color palette */\n$bg: #ffffff;\n$muted: #6b7280;\n$accent: #ff7a00;\n/* primary orange */\n$accent-dark: #e06600;\n$error: #d9534f;\n$border: #e6e6e9;\n$shadow: 0 8px 24px rgba(2, 6, 23, 0.08);\n$radius: 10px;\n$font-stack: Inter, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial;\n\n/* Root form card */\n.form {\n    max-width: 100%;\n    margin: 0 auto;\n    font-family: $font-stack;\n    color: #111827;\n}\n\n/* Top row: tabs left, logos right */\n.topRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 18px;\n}\n\n/* Keep tabs grouped and left-aligned */\n.tabsWrapper {\n    display: flex;\n    align-items: center;\n    flex: 1 1 auto;\n}\n\n/* Tabs */\n.tabs {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.tab {\n    padding: 14px;\n    border: 1px solid #9e9e9e;\n    background: #e6e9ee !important;\n    color: #222222;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background .12s ease, color .12s ease, border-color .12s ease;\n    min-width: 180px;\n    text-align: center;\n}\n\n\n.active {\n    background: #fff !important;\n    color: #000 !important;\n    border: none;\n}\n\n/* Logos wrapper aligns logos to the right */\n.logosWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 0 0 auto;\n}\n\n/* Card logos row styling */\n.cardLogosRow {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    justify-content: flex-end;\n    margin: 0;\n    padding: 0;\n}\n\n/* individual logo container */\n.cardLogo {\n    width: 66px;\n    height: 40px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* ensure SVG scales nicely */\n.cardSvg {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\n/* Panel and headings */\n.panel {\n    padding: 10px 15px;\n}\n\n.required {\n    color: $muted;\n    font-size: 13px;\n    margin-bottom: 12px;\n}\n\n/* Labels and inputs */\n.label {\n    display: block;\n    margin-bottom: 12px;\n    font-size: 14px;\n    color: #111827;\n    margin-left: 0px !important;\n}\n\n.labelSmall {\n    display: block;\n    width: 100%;\n    font-size: 14px;\n    margin-left: 0px !important;\n}\n\n/* Inputs */\n.input,\nselect {\n    display: block;\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid $border;\n    border-radius: 8px;\n    margin-top: 8px;\n    font-size: 14px;\n    background: #fff;\n    color: #111827;\n    transition: border-color .12s ease, box-shadow .12s ease;\n}\n\n.input:focus,\nselect:focus {\n    outline: none;\n    border-color: $accent;\n    box-shadow: 0 0 0 4px rgba(255, 122, 0, 0.06);\n}\n\n.inputError {\n    @extend .input;\n    border-color: $error;\n    box-shadow: 0 0 0 4px rgba(217, 83, 79, 0.06);\n}\n\n/* Row layout */\n.row {\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    margin-bottom: 12px;\n}\n\n.labelSmall {\n    width: 50%;\n}\n\n/* Fieldset */\n.fieldset {\n    border: 1px solid $border;\n    padding: 14px;\n    border-radius: 8px;\n    margin-bottom: 14px;\n    background: #fffaf5;\n}\n\n.legend {\n    font-weight: 700;\n    font-size: 14px;\n    margin-bottom: 8px;\n    color: #7a4a00;\n}\n\n/* Error text */\n.error {\n    color: $error;\n    font-size: 12px;\n    margin-top: 6px;\n    display: block;\n}\n\n/* Card icons row (bottom) */\n.cardIcons {\n    display: flex;\n    gap: 10px;\n    margin-top: 14px;\n    align-items: center;\n}\n\n.icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 10px;\n    border-radius: 6px;\n    background: #fff;\n    border: 1px solid $border;\n    font-size: 13px;\n    color: #374151;\n    min-width: 56px;\n    text-align: center;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n/* Radio labels */\n.radioLabel {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-right: 12px;\n    font-size: 14px;\n}\n\n/* Check sample */\n.checkSample {\n    margin-top: 12px;\n}\n\n.checkGraphic {\n    border: 1px dashed $border;\n    padding: 12px;\n    border-radius: 8px;\n    background: #fff7ed;\n    color: #92400e;\n}\n\n.checkRow {\n    font-size: 13px;\n    margin-bottom: 6px;\n}\n\n/* Actions / submit */\n.actions {\n    display: flex;\n    justify-content: end;\n    margin: 2% 5%;\n}\n\n.submitBtn {\n    background: #ffb034 !important;\n    color: #fff;\n    padding: 12px 18px;\n    border-radius: 0;\n    border: none;\n    font-weight: 700;\n    font-size: 25px;\n    cursor: pointer;\n    transition: transform .06s ease, box-shadow .12s ease;\n}\n\n.form-control{\n    outline: none;\n    width: 100%;\n    border: 1px solid #d7d7d7 !important;\n    \n    &::placeholder{\n        font-style: italic;\n        font-weight: $fw3;\n    }\n}\n\n.paymetric--form select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(../../public/images/myAccount/drop-arrow-gray.png);\n  background-position: 100%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 42px;\n  min-height: 0;\n  max-width: 100%;\n  padding: 0 50px 0 5px;\n  font-size: 14px;\n  border: 1px solid #e6e9ee;\n  color: #222222;\n  font-weight: 300;\n}\n\n.submitBtn:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 10px 26px rgba(224, 102, 0, 0.14);\n}\n/* Responsive */\n@media only screen and (max-width: 768px) {\n    .g-font-size-16, .gfs-16 {\n    font-size: 14px !important;\n}\n    .row {\n        flex-direction: column;\n    }\n\n    .labelSmall {\n        width: 100%;\n    }\n\n    .tabs {\n        flex-direction: column;\n    }\n\n    .tab {\n        min-width: auto;\n        width: 100%;\n    }\n\n    .actions {\n        justify-content: stretch;\n    }\n\n    .submitBtn {\n        width: 100%;\n    }\n\n    /* stack topRow vertically on small screens */\n    .topRow {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n    }\n\n    .logosWrapper {\n        justify-content: flex-start;\n    }\n\n    .cardLogo {\n        \n        \n    }\n}\n\n/* paymentForm.module.scss (append or merge with your existing file) */\n\n/* ACCEPTED CARDS BLOCK */\n.acceptCardsBlock {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 18px;\n    justify-content: flex-start;\n    align-items: start;\n}\n\n/* italic text row (matches g-font-italic gfs-16 paymetric--mb-20) */\n.acceptText {\n    font-style: italic;\n    font-size: 12px;\n    font-weight: 300;\n    padding: 10px 0px 10px !important;\n    color: #666;\n    word-break: break-all;\n}\n\n/* row that contains the small card badges */\n.acceptRow {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n/* base badge style (paymetric--form_card paymetric--form_card-sm) */\n.cardBadge {\n    width: 56px;\n    /* small badge width */\n    height: 34px;\n    /* small badge height */\n    border-radius: 6px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    color: #fff;\n    box-shadow: 0 2px 6px rgba(2, 6, 23, 0.04);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    padding: 4px;\n}\n\n/* Mastercard indicator (mcIndicator) */\n.mcIndicator {\n    background: linear-gradient(90deg, #ff5f4d 0%, #ffb347 100%);\n    color: #fff;\n    position: relative;\n}\n\n.mcIndicator::after {\n    content: \"Mastercard\";\n    font-size: 11px;\n    color: #fff;\n    letter-spacing: 0.2px;\n}\n\n/* Visa indicator (viIndicator) */\n.viIndicator {\n    background: #1a1f71;\n    /* Visa dark blue */\n    color: #fff;\n}\n\n.viIndicator::after {\n    content: \"Visa\";\n    font-size: 12px;\n    color: #fff;\n}\n\n/* AmEx indicator (axIndicator) */\n.axIndicator {\n    background: #2e77bc;\n    /* AmEx blue */\n    color: #fff;\n}\n\n.axIndicator::after {\n    content: \"AmEx\";\n    font-size: 11px;\n    color: #fff;\n}\n\n/* Discover indicator (diIndicator) */\n.diIndicator {\n    background: linear-gradient(90deg, #fff 0%, #fff 100%);\n    color: #ff6a00;\n    border: 1px solid #e6e6e9;\n}\n\n.diIndicator::after {\n    content: \"Discover\";\n    font-size: 10px;\n    color: #ff6a00;\n    font-weight: 700;\n}\n\n/* small responsive tweak */\n@media (max-width: 480px) {\n    .cardBadge {\n        width: 48px;\n        height: 28px;\n        font-size: 10px;\n    }\n\n    .acceptText {\n        font-size: 14px;\n    }\n}\n\n.cardLogosRow {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n}\n\n.cardImg {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n    display: block;\n}\n\n\n.p-0 {\n    padding: 0 !important;\n}\n.align-items-end {\n    align-items: flex-end !important;\n}\n.g-font-size-16, .gfs-16 {\n    font-size: 16px;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.paymetric--form_radio div {\n    bottom: -1px;\n}\n.paymetric--form_radio div {\n    bottom: -1px;\n}\n.d-inline-block {\n    display: inline-block !important;\n}\n.position-relative {\n    position: relative !important;\n}\n.float-left {\n    float: left !important;\n}\n.bg-white-clr {\n      background: #fff !important;\n    border-bottom: 1px solid #fff !important;\n    padding-top: 19px !important;\n    position: relative;\n    z-index: 9;\n}\n\n.paymetric--form_radio label {\n    border: 1px solid #9e9e9e;\n    cursor: pointer;\n}\n.p-14 {\n    padding: 14px;\n}\n.m-0 {\n    margin: 0 !important;\n}\n.g-font-size-16, .gfs-16 {\n    font-size: 16px;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n.g-line-height-1, .glh-1 {\n    line-height: 1 !important;\n}\n.bg-gray-light {\n    background-color: #e6e9ee !important;\n}\n.paymetric--form_radio div:last-child {\n    left: -1px;\n}\n.paymetric--form_radio div {\n    bottom: -1px;\n}\n.d-inline-block {\n    display: inline-block !important;\n}\n.position-relative {\n    position: relative !important;\n}\n.float-left {\n    float: left !important;\n}\n.paymetric--mb-20 {\n    margin-bottom: 20px !important;\n    word-break: break-all;\n}\n.paymetric--form_wrapper {\n    border: 1px solid #9e9e9e;\n}\n.bg-white {\n    color: #666;\n}\n.bg-white {\n    background-color: #fff !important;\n}\n.py-20 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n}\n\n@media only screen and (max-width: 990px) {\n    .paymetric--mb-20 {\n        margin-bottom: 20px !important;\n    }\n}\n.paymetric--form {\n    font-family: $source-sans-pro;\n}\n.g-font-weight-300 {\n    font-weight: 300 !important;\n}\n.sr-only {\n    border: 0;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n}\n.paymetric--form input, .paymetric--form select {\n    border: 1px solid #d7d7d7 !important;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n    color: #666 !important;\n    padding: 8px 18px;\n    left: 0;\n    margin-bottom: 0 !important;\n    @media only screen and (max-width: 767px) {\n        border-radius: 0;\n        font-weight: $fw3;\n    }\n    ::placeholder{\n        font-style: italic !important;\n        font-weight: $fw3;\n    }\n}\n@media only screen and (max-width: 767px) {\n    .paymetric--form input::placeholder{\n        font-style: italic !important;\n        font-weight: $fw3;\n    }\n}\n\n#PaymentForm .paymetric {\n    border: none;\n    min-height: 300px !important;\n}\n.mb-md-0 {\n    margin-bottom: 0 !important;\n}\n\n.paymetric--mb-20 {\n    margin-bottom: 20px !important;\n    word-break: break-all;\n}\n.g-font-italic {\n    font-style: italic !important;\n}\n.g-font-italic.gfs-14.paymetric--mb-20 {\n    margin-top: 16px;\n    display: flex;\n}\n.form-row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -5px;\n    margin-left: -5px;\n    @media only screen and (max-width: 990px) {\n        margin-right: 15px;\n        margin-left: 15px;\n    }\n}\n#PaymentForm .paymetric--form_card-sm {\n    height: 35px !important;\n    opacity: 1 !important;\n}\n.paymetric--form_card {\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    float: left;\n    height: 50px;\n    width: 83px;\n    @media only screen and (max-width: 767px) {\n        opacity: 1;\n        img{\n            height: 35px;\n        }\n    }\n}\n\n.gfs-14{\n    font-size: 14px !important;\n}\n.btn-primary {\n    background-color: #ffb034 !important;\n}\n.btn-orange {\n    background-color: #ffb034 !important;\n    color: #fff !important;\n    font-size: 26px !important;\n    font-weight: 700 !important;\n    @media only screen and (max-width: 767px) {\n        line-height: 1.3 !important;\n        border-radius: 0 !important;\n        width: 100% !important;\n    }\n}","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successOverlay": `paymentForm_successOverlay__Mrhx0`,
	"successModal": `paymentForm_successModal__ZRFPZ`,
	"successClose": `paymentForm_successClose__KgT6e`,
	"successBody": `paymentForm_successBody__c1nGb`,
	"successTitle": `paymentForm_successTitle__Lns1X`,
	"successText": `paymentForm_successText__AifVq`,
	"successActions": `paymentForm_successActions__Q55Bs`,
	"successOk": `paymentForm_successOk__9yUV4`,
	"loaderOverlay": `paymentForm_loaderOverlay__2+NPG`,
	"form": `paymentForm_form__S5nx3`,
	"topRow": `paymentForm_topRow__k91Xc`,
	"tabsWrapper": `paymentForm_tabsWrapper__i7UpG`,
	"tabs": `paymentForm_tabs__NplNR`,
	"tab": `paymentForm_tab__WDVH7`,
	"active": `paymentForm_active__hj4xY`,
	"logosWrapper": `paymentForm_logosWrapper__aIpnv`,
	"cardLogosRow": `paymentForm_cardLogosRow__2RqKx`,
	"cardLogo": `paymentForm_cardLogo__Iat54`,
	"cardSvg": `paymentForm_cardSvg__+aqOn`,
	"panel": `paymentForm_panel__p3zO6`,
	"required": `paymentForm_required__QrQjs`,
	"label": `paymentForm_label__VSux6`,
	"labelSmall": `paymentForm_labelSmall__5ZiOZ`,
	"input": `paymentForm_input__Gn0Qy`,
	"inputError": `paymentForm_inputError__o4LoF`,
	"row": `paymentForm_row__XfeYM`,
	"fieldset": `paymentForm_fieldset__pxmwD`,
	"legend": `paymentForm_legend__1ett+`,
	"error": `paymentForm_error__3rGj9`,
	"cardIcons": `paymentForm_cardIcons__s8SBG`,
	"icon": `paymentForm_icon__QkBvh`,
	"radioLabel": `paymentForm_radioLabel__XYsHx`,
	"checkSample": `paymentForm_checkSample__T7zpn`,
	"checkGraphic": `paymentForm_checkGraphic__iN5oj`,
	"checkRow": `paymentForm_checkRow__kLp7x`,
	"actions": `paymentForm_actions__07Ff1`,
	"submitBtn": `paymentForm_submitBtn__ikImx`,
	"form-control": `paymentForm_form-control__m1n37`,
	"paymetric--form": `paymentForm_paymetric--form__A8JCJ`,
	"g-font-size-16": `paymentForm_g-font-size-16__cb9cF`,
	"gfs-16": `paymentForm_gfs-16__tNT0g`,
	"acceptCardsBlock": `paymentForm_acceptCardsBlock__Gr-bK`,
	"acceptText": `paymentForm_acceptText__bcVue`,
	"acceptRow": `paymentForm_acceptRow__FfMcZ`,
	"cardBadge": `paymentForm_cardBadge__8W902`,
	"mcIndicator": `paymentForm_mcIndicator__q9lZ-`,
	"viIndicator": `paymentForm_viIndicator__m1-q+`,
	"axIndicator": `paymentForm_axIndicator__eMAAT`,
	"diIndicator": `paymentForm_diIndicator__3ZY9O`,
	"cardImg": `paymentForm_cardImg__r7P7D`,
	"p-0": `paymentForm_p-0__oqyEK`,
	"align-items-end": `paymentForm_align-items-end__k7ldT`,
	"g-font-weight-300": `paymentForm_g-font-weight-300__31oIm`,
	"gfw-3": `paymentForm_gfw-3__7s8x-`,
	"g-line-height-1_2": `paymentForm_g-line-height-1_2__8Zts1`,
	"glh-1_2": `paymentForm_glh-1_2__rcrYh`,
	"paymetric--form_radio": `paymentForm_paymetric--form_radio__5tRPZ`,
	"d-inline-block": `paymentForm_d-inline-block__JI0Hg`,
	"position-relative": `paymentForm_position-relative__syJpR`,
	"float-left": `paymentForm_float-left__fkzmS`,
	"bg-white-clr": `paymentForm_bg-white-clr__LP0Ut`,
	"p-14": `paymentForm_p-14__XmylH`,
	"m-0": `paymentForm_m-0__kmW+6`,
	"g-font-weight-700": `paymentForm_g-font-weight-700__ND85V`,
	"gfw-7": `paymentForm_gfw-7__zCYkv`,
	"g-line-height-1": `paymentForm_g-line-height-1__FlzHI`,
	"glh-1": `paymentForm_glh-1__BhaXq`,
	"bg-gray-light": `paymentForm_bg-gray-light__uEqRW`,
	"paymetric--mb-20": `paymentForm_paymetric--mb-20__tbb6d`,
	"paymetric--form_wrapper": `paymentForm_paymetric--form_wrapper__r9pGy`,
	"bg-white": `paymentForm_bg-white__Xw-JC`,
	"py-20": `paymentForm_py-20__YtlM1`,
	"sr-only": `paymentForm_sr-only__HFfaE`,
	"PaymentForm": `paymentForm_PaymentForm__IwYkZ`,
	"paymetric": `paymentForm_paymetric__zYfUm`,
	"mb-md-0": `paymentForm_mb-md-0__Kyblb`,
	"g-font-italic": `paymentForm_g-font-italic__utfvi`,
	"gfs-14": `paymentForm_gfs-14__e8wxT`,
	"form-row": `paymentForm_form-row__eJLj+`,
	"paymetric--form_card-sm": `paymentForm_paymetric--form_card-sm__YYW9X`,
	"paymetric--form_card": `paymentForm_paymetric--form_card__xqhZC`,
	"btn-primary": `paymentForm_btn-primary__HHLUa`,
	"btn-orange": `paymentForm_btn-orange__vDwal`
};
export default ___CSS_LOADER_EXPORT___;
